import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseAPIArray, BaseApiService } from '../services/base-api.service';
import { HelpersService } from '../services/helpers.service';
import { ProgressService } from '../services/progress.service';
import { LoadingService } from '../services/loading.service';
import { share } from 'rxjs';
import { HttpQuery } from '../services/http-query';

@Injectable({
  providedIn: 'root',
})
export class HomeService extends BaseApiService<any> {
  constructor(
    public override http: HttpClient,
    public override helper: HelpersService,
    public override loading: ProgressService,
    public override loadingService: LoadingService
  ) {
    super(http, helper, loading, loadingService);
    this.endpoint = 'report';
    this.query = { limit: 0, page: 0 };
  }

  getStatistic(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('dashboard-statistic');
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  getLog(): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('dashboard-log');
      this.loadingService.startLoading();
      this.http
        .get<any>(url)
        .pipe(share())
        .subscribe({
          next: ({ data }) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }
}
